
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class FranchiseeOutstandingDialog extends Serenity.EntityDialog<FranchiseeOutstandingRow, any> {
        protected getFormKey() { return FranchiseeOutstandingForm.formKey; }
        protected getIdProperty() { return FranchiseeOutstandingRow.idProperty; }
        protected getLocalTextPrefix() { return FranchiseeOutstandingRow.localTextPrefix; }
        protected getService() { return FranchiseeOutstandingService.baseUrl; }
        protected getDeletePermission() { return FranchiseeOutstandingRow.deletePermission; }
        protected getInsertPermission() { return FranchiseeOutstandingRow.insertPermission; }
        protected getUpdatePermission() { return FranchiseeOutstandingRow.updatePermission; }

        protected form = new FranchiseeOutstandingForm(this.idPrefix);

    }
}